import { createContext, useContext, useEffect, useId, useState } from 'react';
function createRegistry() {
    const dirtyIds = new Set();
    return {
        set: (id, dirty) => {
            if (dirty)
                dirtyIds.add(id);
            else
                dirtyIds.delete(id);
        },
        hasUnsavedChanges: () => dirtyIds.size > 0,
        clear: () => dirtyIds.clear(),
    };
}
export const UnsavedChangesContext = createContext(null);
/** Shell side: one stable registry for the lifetime of the Settings modal. */
export function useUnsavedChangesRegistry() {
    const [registry] = useState(createRegistry);
    return registry;
}
/**
 * Section side. Outside the Settings shell (a section rendered on its own, as
 * in tests) there is no registry and this is a no-op.
 */
export function useSettingsUnsavedChanges(dirty) {
    const registry = useContext(UnsavedChangesContext);
    const id = useId();
    useEffect(() => {
        registry?.set(id, dirty);
    }, [registry, id, dirty]);
    // Unmounting (after a save, a discard, or a category switch) is never dirty.
    useEffect(() => () => registry?.set(id, false), [registry, id]);
}
